<script>
export default {
  props: {
    index: { type: Number, required: true },
    item: { type: Object, required: true },
    enableDetails: { type: Boolean, default: false },
    headers: { type: Array, required: true },
    striped: { type: Boolean, default: false },
    variant: { type: String, default: 'primary' },
    selectedIndex: { type: Number, default: 0 },
    showSelected: { type: Boolean, default: false },
  },
  computed: {
    getBodyTrColorClass() {
      return this.variant === 'primary'
        ? 'body-tr-primary'
        : 'body-tr-secondary';
    },
  },
};
</script>

<template>
  <div>
    <tr
      class="body-tr"
      @mouseenter="(e) => $emit('rowMouseEnter', e, index)"
      @mouseleave="(e) => $emit('rowMouseLeave', e, index)"
      :class="[
        showSelected && index === selectedIndex && 'body-tr-bg-selected',
        index % 2 === 1 && striped && 'body-tr-bg-secondary',
        getBodyTrColorClass,
      ]"
    >
      <td
        v-for="header in headers"
        :key="`${header.key}-${index}`"
        :style="{ width: header.width }"
        class="body-td"
      >
        <div class="body-td-content">
          <slot
            :name="`body-${header.key}`"
            :header="header"
            :item="item"
            :index="index"
          >
            {{ item[header.key] }}
          </slot>
        </div>
      </td>
    </tr>
    <tr
      v-if="enableDetails && item.showDetails"
      class="body-tr row-details-box"
    >
      <td :colspan="headers.length">
        <slot name="row-details" :item="item"></slot>
      </td>
    </tr>
  </div>
</template>

<style lang="scss" scoped>
.body-tr {
  display: table;
  width: 100%;
  table-layout: fixed;
  height: 32px;
}
.body-tr-primary {
  background-color: rgb(41, 44, 50);
}
.body-tr-secondary {
  background-color: $bg-secondary;
  border-bottom: 0.063rem solid rgb(49, 49, 49);
  height: auto;
}
.body-tr-bg-secondary {
  background-color: $bg-secondary;
}
.body-td {
  border-top: 5px solid $bg-secondary;
  border-bottom: 5px solid $bg-secondary;
  padding: 5px 4px 5px 2rem;
}
.body-td-content {
  @include flex-center-vert;
  height: 100%;
}
.row-details-box {
  border-left: 0.825rem solid $bg-secondary;
  border-right: 0.825rem solid $bg-secondary;
  margin-top: -0.322rem;
  width: 100%;
}
.body-td:first-child {
  border-left: 0.825rem solid $bg-secondary;
  padding-left: 1.175rem;
}
.body-td:last-child {
  border-right: 0.825rem solid $bg-secondary;
}
.body-tr-bg-selected {
  background-color: $color-brand-accent-selected;
}
</style>
